import {
    X
} from "lucide-react";

import "./Drawer.css";

export default function Drawer({

    open,

    title,

    subtitle,

    width = 680,

    children,

    footer,

    onClose

}){

    if(!open){

        return null;

    }

    return(

        <>

            <div

                className="drawer-sidebar-backdrop"

                onClick={onClose}

            />

            <aside

                className="drawer-sidebar"

                style={{

                    width

                }}

            >

                <div className="drawer-sidebar-header">

                    <div>

                        <h2>

                            {title}

                        </h2>

                        {

                            subtitle &&

                            <p>

                                {subtitle}

                            </p>

                        }

                    </div>

                    <button

                        className="drawer-sidebar-close"

                        onClick={onClose}

                    >

                        <X size={20}/>

                    </button>

                </div>

                <div className="drawer-sidebar-body">

                    {children}

                </div>

                {

                    footer &&

                    <div className="drawer-sidebar-footer">

                        {footer}

                    </div>

                }

            </aside>

        </>

    );

}